import { Box, Grid, Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import React from 'react';

export interface InfoCardProps {
  icon: React.ReactElement;
  label: string;
  valueText: string;
  color?: string;
  clampLines?: number;
  showTooltip?: boolean;
  endAdornment?: React.ReactNode;
}

const InfoCard: React.FC<InfoCardProps> = ({
  icon,
  label,
  valueText,
  color = 'primary.main',
  clampLines,
  showTooltip,
  endAdornment,
}) => (
  <Grid item xs={12} sm={6} md={4}>
    <Box display="flex" alignItems="center" gap={1}>
      <Box
        sx={{
          backgroundColor: `${color}15`,
          borderRadius: '50%',
          p: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {React.cloneElement(icon, {
          sx: { fontSize: '0.8rem', color },
        })}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: '0.65rem' }}
        >
          {label}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {showTooltip ? (
            <LightTooltip
              title={
                <Box
                  sx={{
                    p: 2,
                    maxWidth: 360,
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                  }}
                >
                  <Typography variant="body1">{valueText}</Typography>
                </Box>
              }
              placement="top"
            >
              <Typography
                variant="body2"
                fontWeight="medium"
                sx={{
                  fontSize: '0.75rem',
                  ...(clampLines
                    ? {
                        display: '-webkit-box',
                        WebkitLineClamp: clampLines,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }
                    : {}),
                }}
              >
                {valueText}
              </Typography>
            </LightTooltip>
          ) : (
            <Typography
              variant="body2"
              fontWeight="medium"
              sx={{ fontSize: '0.75rem' }}
            >
              {valueText}
            </Typography>
          )}
          {endAdornment}
        </Box>
      </Box>
    </Box>
  </Grid>
);

export default InfoCard;
